import React, {useEffect, useRef, useState} from "react";
import {Button, Modal} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationCircle, faEye, faEyeSlash, faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import ModalControls from "../../common/ModalControls";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {defaultFormState} from "../../../../defaults/Forms";
import {employeeProfileDefault} from "../../../../defaults/Items";
import {
  compareData,
  onCloseDetails,
  onItemsListDeleteButtonClick,
  restoreFormData
} from "../../../../helpers/ComponentHelper";
import LoadingDataDiv from "../../common/LoadingDataDiv";
import useCrud from "../../../../hooks/useCrud";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import useAxiosPrivateFileUpload from "../../../../hooks/useAxiosPrivateFileUpload";
import {ToastContainer} from "react-toastify";
import {toastError, toastSuccess} from "../../../../helpers/Toast";
import useAuth from "../../../../hooks/useAuth";
import TextInput from "../../../elements/TextInput";
import EmployeeSelfDocumentsCard from "./EmployeeSelfDocumentsCard";

const EmployeeProfile = () => {

  const {auth} = useAuth();
  const {id} = useParams();

  const dataUrl = "/employee-profile";
  const defaultItem = employeeProfileDefault;
  const itemName = "pracownik";
  const itemNames = "pracownicy";
  const axiosPrivate = useAxiosPrivate();
  const axiosPrivateFileUpload = useAxiosPrivateFileUpload();

  const navigate = useNavigate();
  const location = useLocation();
  const {updateItem, getItems} = useCrud(dataUrl);

  const [loading, setLoading] = useState(true);
  const [allowDelete, setAllowDelete] = useState(null);
  const [currentFormState, setCurrentFormState] = useState(defaultFormState);
  const [itemsList, setItems] = useState([]);
  const [currentItem, setCurrentItem] = useState(defaultItem);
  const [backupItem, setBackupItem] = useState(defaultItem);
  const [itemChanged, setItemChanged] = useState(false);
  const [validPassword, setValidPassword] = useState(false);
  const [updateConflict, setUpdateConflict] = useState(false);
  const [showDeptGuard, setShowDeptGuard] = useState(false);
  const [profileError, setProfileError] = useState(null);
  const hiddenFileInput = useRef(null);

  const [showPasswordSection, setShowPasswordSection] = useState(false);
  const [passwordsEqual, setPasswordsEqual] = useState(true);
  const [passwordIsValid, setPasswordIsValid] = useState(false);
  const [oldPwdVisible, setOldPwdVisible] = useState(false);
  const [newPwdVisible, setNewPwdVisible] = useState(false);
  const [confPwdVisible, setConfPwdVisible] = useState(false);
  const oldPasswordRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmationRef = useRef();
  const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%]).{8,24}$/; // requires 1 uppercase letter, 1 lowercase letter, 1 digit, 1 special char and has to be 8-24 chars long

  const passwordToggler = (passwordField, passwordTogglerIcon, setPasswordVisible) => {
    const password = document.getElementById(passwordField);
    const toggler = document.getElementById(passwordTogglerIcon);
    const isPasswordVisible = password.type === "password";
    password.type = isPasswordVisible ? "text" : "password";
    toggler.classList.toggle("pwd_visible", isPasswordVisible);
    setPasswordVisible(isPasswordVisible);
  };


  const comparePasswords = (e) => {

    const oldPasswordField = document.getElementById("oldPassword");
    const passwordField = document.getElementById("password");
    const passwordConfirmationField = document.getElementById("passwordConf");
    const oldPassword = oldPasswordField.value;
    const newPassword = passwordField.value;
    const passwordConfirmation = passwordConfirmationField.value;
    const passwordsAreEqual = newPassword === passwordConfirmation
    setPasswordsEqual(passwordsAreEqual);

    if (((newPassword && PWD_REGEX.test(newPassword)) || newPassword === "123" || newPassword === "abc") && (oldPassword !== "" && newPassword !== "" && newPassword === passwordConfirmation )) {
      setPasswordIsValid(true);
      setValidPassword(true);
      setCurrentItem(prev => ({
        ...prev,
        oldPassword: oldPassword,
        password: newPassword
      }))

    }

    if ((newPassword && !PWD_REGEX.test(newPassword) && newPassword !== "123" && newPassword !== "abc") || !oldPassword || !newPassword || !passwordConfirmation) {
      setPasswordIsValid(false);
      setValidPassword(false);
    }
  }


  const togglePasswordSection = () => {

    if (!showPasswordSection) {
      setShowPasswordSection(true);

    } else {
      const passwordField = document.getElementById("password");
      const passwordConfirmationField = document.getElementById("passwordConf");
      const oldPasswordField = document.getElementById("oldPassword");
      const backupItem = state.backupItem;
      passwordField.value = "";
      passwordConfirmationField.value = "";
      oldPasswordField.value = "";
      state.currentItem.password = null;

      const propertiesAreEqual = Object.keys(state.currentItem).every(key => {
        if (key === 'password') return true; // Ignore password for comparison
        return state.currentItem[key] === backupItem[key];
      });

      if (state.currentItem.password === null && propertiesAreEqual) {
        state.setCurrentFormState({
          ...state.currentFormState,
          formSaveButtonDisabled: true,
        });
      }
      setShowPasswordSection(false);
      setValidPassword(false);
      setPasswordIsValid(false);

    }
  }



  const validatePassword = (newPassword) => {

    if (currentFormState.formAddingDataMode && newPassword === "") {
      setValidPassword(false);
      return;
    }

    // TODO Remove 123 and ABC from valid cases
    if ((newPassword && !PWD_REGEX.test(newPassword)) && newPassword !== "123" && newPassword !== "ABC") {
      setValidPassword(false);
      return false;
    }
    return true;
  }

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)


  const onSaveItemClick = async (e) => {
    e.preventDefault();


    let formHasErrors = false;

    if (!currentItem.firstName) {
      let firstNameInput = document.getElementById("firstName");
      firstNameInput.classList.add("form-input-invalid");
      firstNameInput.placeholder = `ten element jest wymagany`;
      formHasErrors = true;
      toastError("Uzupełnij pole Imię");
    }
    if (!currentItem.lastName) {
      let lastNameInput = document.getElementById("lastName");
      lastNameInput.classList.add("form-input-invalid");
      lastNameInput.placeholder = `ten element jest wymagany`;
      formHasErrors = true;
      toastError("Uzupełnij pole Nazwisko");
    }
    if (!currentItem.companyEmail && !currentItem.privateEmail) {
      let privateEmailInput = document.getElementById("privateEmail");
      privateEmailInput.classList.add("form-input-invalid");
      privateEmailInput.placeholder = `ten element jest wymagany jeśli brak służbowego adresu email`;
      formHasErrors = true;
      toastError("Prywatny adres email jest wymagany w przypadku braku służbowego adresu email");
    }


    if (formHasErrors) return;


    let response;

    const item = {
      id: currentItem.id,
      login: currentItem.login,
      firstName: currentItem.firstName,
      lastName: currentItem.lastName,
      primaryPhone: currentItem.primaryPhone,
      privateEmail: currentItem.privateEmail,
      companyEmail: currentItem.companyEmail
    }

    // console.log(item);
    // return;

    response = await updateItem(`${dataUrl}/${item.id}`, item, state);

    if (response.status === 401) {
      navigate('/login', {state: {from: location}, replace: true});
    } else if (response.status === 403) {
      navigate('/unauthorized', {state: {from: location}, replace: true});
    } else if (response.status === 409) {
      setUpdateConflict(true);
    } else {
      if (response) {
        setCurrentItem(state.currentItem);
        setBackupItem(currentItem);
        setCurrentFormState({
          ...currentFormState,
          showForm: false,
          formSaveButtonDisabled: true,
          formAddingDataMode: false
        })
        toastSuccess("Dane zostały zapisane");
      }

    }

  }



  const savePassword = async (e) => {

    let response;

    const item = {
      id: currentItem.id,
      login: currentItem.login,
      firstName: currentItem.firstName,
      lastName: currentItem.lastName,
      primaryPhone: currentItem.primaryPhone,
      oldPassword: currentItem.oldPassword,
      password: currentItem.password
    }

    response = await updateItem(`${dataUrl}/pwd/${item.id}`, item, state);

    if (response.status === 401) {
      navigate('/login', {state: {from: location}, replace: true});
    } else if (response.status === 403) {
      navigate('/unauthorized', {state: {from: location}, replace: true});
    } else if (response.status === 409) {
      setUpdateConflict(true);
    } else if (response.status === 422 && response.data?.message === "Old password is invalid") {
      setPasswordIsValid(false);
      setValidPassword(false);
      toastError("Stare hasło jest nieprawidłowe");
    } else if (response.status === 200) {
      if (response) {
        setCurrentItem(state.currentItem);
        setBackupItem(currentItem);
        setCurrentFormState({
          ...currentFormState,
          showForm: false,
          formSaveButtonDisabled: true,
          formAddingDataMode: false
        })
        setShowPasswordSection(false);
        toastSuccess("Hasło zostało zmienione");
      }

    } else {

      setPasswordIsValid(false);
      setValidPassword(false);
      setCurrentItem(prev => ({
        ...prev,
        oldPassword: "",
        password: ""
      }))
      setBackupItem(currentItem);
      setShowPasswordSection(false);
      toastError("Hasło nie zostało zmienione");
    }

  }




  const onClose = () => {
    setUpdateConflict(false);
    onCloseDetails({state})
  };


  useEffect(() => {
    if (updateConflict) setUpdateConflict(false);
    compareData(currentFormState, setCurrentFormState, currentItem, backupItem);
//    console.log("CURRENT ITEM:" + currentItem.firstName + "/" + currentItem.photos);
  }, [itemChanged])


  useEffect(() => {
    if (allowDelete !== null) {
      onItemsListDeleteButtonClick(currentFormState, setCurrentFormState, itemName, allowDelete);
    }
  }, [allowDelete])


  useEffect(() => {
    const getData = async () => {
      const [itemsData] =
        await Promise.all([
          getItems(`${dataUrl}/me`)
        ]);

      const success = itemsData.status === 200;

      if (success) {
        setProfileError(null);
        setLoading(false);
        setCurrentItem(itemsData.data);
      } else if (itemsData.status === 401) {
        navigate('/login', {state: {from: location}, replace: true});
      } else if (itemsData.status === 403) {
        navigate('/unauthorized', {state: {from: location}, replace: true});
      } else {
        setLoading(false);
        setProfileError(itemsData.status === 404
          ? "To konto aplikacji nie jest powiązane z kartoteką pracownika."
          : "Nie udało się pobrać danych profilu pracownika.");
      }
    };

    getData();
  }, [location.key])


  const state = {
    itemsList, setItems,
    currentItem, setCurrentItem,
    currentFormState, setCurrentFormState,
    defaultItem, backupItem, setBackupItem, itemChanged, setItemChanged,
    setAllowDelete, validPassword, setValidPassword,
    showDeptGuard, setShowDeptGuard,
  }


  let dataSectionContent;
  if (loading) {
    dataSectionContent = <LoadingDataDiv/>
  } else if (itemsList.length > 0) {
    dataSectionContent =
      <div>
        TABELA
      </div>
    // console.log(itemsList);
  } else {
    dataSectionContent = <h6>NO DATA FOUND, PLEASE ADD A NEW `${itemName.toUpperCase()}`</h6>
  }


  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };


  const handleNavigation = (e, sectionId, tabKey) => {
    e.preventDefault();

    setTimeout(() => {
      const target = document.getElementById(sectionId);
      if (target) {
        const headerOffset = 200;
        const elementPosition = target.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }, 200);
  };


  function createMailbox() {
    if (!currentItem.companyEmail|| currentItem.companyEmail === "") {
      setCurrentItem(prev => ({
        ...prev,
        companyEmail: currentItem.login + "@farmailuzji.pl"
      }))
    }
  }

  if (profileError) {
    return (
      <div id="layoutSidenav_content">
        <ToastContainer/>
        <div className="container-fluid px-4 py-4">
          <div className="alert alert-warning" role="alert">
            <strong>Brak profilu pracownika.</strong> {profileError}
          </div>
          <Button variant="secondary" onClick={() => navigate('/app/dashboard')}>Wróć do tablicy</Button>
        </div>
      </div>
    );
  }

  return (
    <div id="layoutSidenav_content">
      <ToastContainer/>

      <div className="app-component-card-header shadow d-flex justify-content-between align-items-center">
        <div className="text-light-grey">Moje konto: <span className="text-dark">{currentItem.login}</span></div>
        <div>
          <p className="text-center w-responsive mx-auto mb-1 data_changed" id="data-changed"><FontAwesomeIcon
            icon={faExclamationCircle}/>&nbsp;{currentFormState.formDataChangedWarning}</p>
          <Button variant="secondary" id="btn-restore" className="btn-restore" onClick={() => {
            setUpdateConflict(false)
            const pwdConfirmationField = document.getElementById("password1");
            if (pwdConfirmationField) {
              pwdConfirmationField.value = null;
            }
            restoreFormData({state})
          }}>
            Wyczyść zmiany
          </Button>
        </div>

      </div>


      <div className="container-fluid px-4">
        <div className="custom-modal shadow rounded" id="modal_wrapper">
          <div className="custom-modal-body">
            <section className="mb-4">
              <p className="text-center w-responsive mx-auto mb-1 form_test">{currentFormState.formDescription}</p>
              <div className="row">
                <div className="col-md-12 mb-md-0 mb-1" id="wrapper">
                  <form id="employee-profile-form" name="employee-profile-form">
                    <div id="basic-data">
                      <div className="row mb-2">
                        <div className="col-md-12">

                          <div className="row ms-3 mb-4">
                            <div className="col-md-1">
                            <Button variant="primary" id="password-close" onClick={() => {
                              togglePasswordSection()
                            }}>
                              Zmień hasło
                            </Button>
                            </div>
                          </div>



                          <div className="row ms-3">
                            <div className="col-md-1">
                              <div className="md-form mb-0">
                                <label htmlFor="login" className="form-label">Login</label>
                                <TextInput propertyName="login" required={true} state={state} disabled={true}/>
                              </div>
                            </div>

                            <div className="col-md-2">
                              <div className="md-form mb-0">
                                <label htmlFor="companyEmail" className="form-label">Email firmowy</label>
                                <TextInput propertyName="companyEmail" required={true} state={state} disabled={true}/>
                              </div>
                            </div>

                            <div className="col-md-1 d-flex flex-column-reverse">
                              <div className="md-form mb-0">
                                <Button variant="outline-dark" size="sm" id="create-mailbox" disabled={!!currentItem.companyEmail} onClick={() => {
                                  createMailbox();
                                }}>
                                  Utwórz
                                </Button>
                                <Button variant="outline-warning" size="sm" id="create-mailbox" className="ms-1" disabled={!currentItem.companyEmail} onClick={() => {
                                  // createMailbox();
                                }}>
                                  Wyłącz
                                </Button>
                              </div>
                            </div>

                            <div className="col-md-1">
                              <div className="md-form mb-0">
                                <label htmlFor="timeCardId" className="form-label">Karta RCP</label>
                                <TextInput propertyName="timeCardId" required={true} state={state} disabled={true}/>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-md-12">
                          <div className="row ms-3">

                            <div className="col-md-2">
                              <div className="md-form mb-0">
                                <label htmlFor="firstName" className="form-label">Imię <span
                                  className="required">*</span></label>
                                <TextInput propertyName="firstName" required={true} state={state} disabled={false}/>
                              </div>
                            </div>

                            <div className="col-md-2">
                              <div className="md-form mb-0">
                                <label htmlFor="lastName" className="form-label">Nazwisko <span
                                  className="required">*</span></label>
                                <TextInput propertyName="lastName" required={true} state={state} disabled={false}/>
                              </div>
                            </div>

                            <div className="col-md-1">
                              <div className="md-form mb-0">
                                <label htmlFor="primaryPhone" className="form-label">Telefon <span
                                  className="required">*</span></label>
                                <TextInput propertyName="primaryPhone" required={true} state={state} disabled={false}/>
                              </div>
                            </div>

                            <div className="col-md-1">
                              <div className="md-form mb-0">
                                <label htmlFor="privateEmail" className="form-label">Email prywatny <span
                                  className="required">*</span></label>
                                <TextInput propertyName="privateEmail" required={true} state={state} disabled={false}/>
                              </div>
                            </div>


                          </div>
                        </div>
                      </div>

                    </div>

                    <EmployeeSelfDocumentsCard/>

                    <Modal className="mt-5" show={showPasswordSection} backdrop="static" keyboard={false} size={'lg'}>

                      <div className="custom-modal shadow rounded" id="modal_wrapper">
                        <div className="ms-2 fs-4 fw-bold">Zmiana hasła</div>
                        <div className="custom-modal-body mt-4 mb-4">

                            <div
                              className={"row form-group mb-2" + (!state.currentFormState.formAddingDataMode ? "" : " offscreen")}>
                              <div className="col-md-2 form-label">
                                <label htmlFor="oldPassword" className=""><span className="required">*</span> Stare
                                  hasło</label>
                              </div>
                              <div className="col-md-4"
                                   style={{display: "flex", flexDirection: "column", position: "relative"}}>
                                <div style={{display: "flex", alignItems: "center"}}>
                                  <input
                                    className="form-control"
                                    type="password"
                                    id="oldPassword"
                                    required
                                    ref={oldPasswordRef}
                                  />
                                  <span id="oldPassword_toggler" className="password_toggler"
                                        onClick={() => passwordToggler("oldPassword", "oldPassword_toggler", setOldPwdVisible)}><FontAwesomeIcon
                                    icon={oldPwdVisible ? faEye : faEyeSlash}/></span>
                                </div>
                              </div>
                            </div>

                            <div className="row form-group mb-2">
                              <div className="col-md-2 form-label">
                                <label htmlFor="password0" className=""><span className="required">*</span> Nowe
                                  hasło</label>
                              </div>
                              <div className="col-md-4"
                                   style={{display: "flex", flexDirection: "column", position: "relative"}}>
                                <div style={{display: "flex", alignItems: "center"}}>
                                  <input
                                    className="form-control"
                                    type="password"
                                    id="password"
                                    onChange={(e) => comparePasswords(e)}
                                    required
                                    ref={passwordRef}
                                  />
                                  <span id="password_toggler" className="password_toggler"
                                        onClick={() => passwordToggler("password", "password_toggler", setNewPwdVisible)}><FontAwesomeIcon
                                    icon={newPwdVisible ? faEye : faEyeSlash}/></span>
                                </div>
                                <p id="pwdnote" className={!passwordIsValid ? "err_info" : "offscreen"}>
                                  <FontAwesomeIcon icon={faInfoCircle}/>&nbsp;
                                  8 do 24 znaków. Musi zawierać przynajmniej jedną wielką i jedną małą literę, cyfrę i
                                  znak specjalny.
                                  Dozwolone znaki specjalne: <span aria-label="exclamation mark">!</span> <span
                                  aria-label="at symbol">@</span> <span aria-label="hashtag">#</span> <span
                                  aria-label="dollar sign">$</span>
                                  <span aria-label="percent">%</span>
                                </p>
                              </div>
                            </div>

                            <div className="row form-group mb-2">
                              <div className="col-md-2 form-label">
                                <label htmlFor="password1" className=""><span className="required">*</span> Potwierdź
                                  hasło</label>
                              </div>
                              <div className="col-md-4"
                                   style={{display: "flex", flexDirection: "column", position: "relative"}}>
                                <div style={{display: "flex", alignItems: "center"}}>
                                  <input
                                    className="form-control"
                                    type="password"
                                    id="passwordConf"
                                    onChange={(e) => comparePasswords(e)}
                                    required
                                    ref={passwordConfirmationRef}
                                  />
                                  <span id="passwordConf_toggler" className="password_toggler"
                                        onClick={() => passwordToggler("passwordConf", "passwordConf_toggler", setConfPwdVisible)}><FontAwesomeIcon
                                    icon={confPwdVisible ? faEye : faEyeSlash}/></span>
                                </div>
                                <p id="pwdnote" className={!passwordsEqual ? "err_info" : "offscreen"}>
                                  <FontAwesomeIcon icon={faInfoCircle}/>&nbsp;
                                  Podane hasła są różne
                                </p>
                              </div>

                            </div>

                        </div>
                      </div>

                      <Modal.Footer>
                        <Button variant="secondary" id="password-close-cancel" disabled={false} onClick={() => {
                          togglePasswordSection();
                        }}>
                          Anuluj
                        </Button>
                        <Button variant="primary" id="password-close" disabled={!validPassword} onClick={() => {
                          savePassword();
                        }}>
                          Zapisz
                        </Button>
                      </Modal.Footer>
                    </Modal>


                  </form>


                  <p id="conflict_notification" className={updateConflict ? "err_info" : "offscreen"}>
                    <FontAwesomeIcon icon={faInfoCircle}/>&nbsp;
                    Nie można dodać ani zmienić tego elementu, ponieważ istnieje już wpis o tej nazwie i/lub skrócie
                  </p>

                </div>

              </div>
            </section>

          </div>
          <div className="modal-controls">
            <ModalControls
              onDelete={null}
              onCloseDetails={onClose}
              onSubmit={onSaveItemClick}
              state={state}
            />
          </div>
        </div>

      </div>


      <Modal show={showDeptGuard} onHide={() => setShowDeptGuard(false)} centered>
        <Modal.Header className="form-header-warning" closeButton closeVariant="white">
          <Modal.Title>Nie można zmienić działu</Modal.Title>
        </Modal.Header>
        <Modal.Body>Aby zmienić dział, usuń najpierw wszystkie wybrane stanowiska pracownika.</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowDeptGuard(false)}>OK</Button>
        </Modal.Footer>
      </Modal>

    </div>
  );


}

export default EmployeeProfile;

